import { D } from '@tanstack/react-query-devtools/build/legacy/ReactQueryDevtools-Cn7cKi7o';
import styled from 'styled-components';

import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import { ReportSectionText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

interface MissionProgressGraphProps {
	contractedMembers?: number;
	productPurchase: {
		count: number;
		link?: string[] | null;
	};
	draftSend: {
		count: number;
		link?: string | null;
	};
	reelsUpload: {
		count: number;
		link?: string | null;
	};
	styleClipUpload: {
		count: number;
		link?: string | null;
	};
}

// 전체 타입

const GRAPH_TITLE = ['제품 구매', '초안 전달', '릴스 업로드', '스타일클립 업로드'];

const MissionProgressGraph = ({
	contractedMembers,
	productPurchase,
	draftSend,
	reelsUpload,
	styleClipUpload,
}: MissionProgressGraphProps) => {
	return (
		<Grid flex="start" direction="column" _gap="20px">
			<Grid>
				<Grid flex="between">
					<Grid flex="start" direction="row" _gap="4px">
						<ReportSectionText>{GRAPH_TITLE[0]}</ReportSectionText>
						<Grid flex="start" _gap="8px">
							{productPurchase.link?.map((link, index) => (
								<a
									key={encodeURIComponent(link)}
									href={link}
									target="_blank"
									rel="noreferrer"
								>
									<Grid flex="start">
										<Text typo="span" style={{ textDecoration: 'underline' }}>
											Link{index + 1}
										</Text>
										<CoreSvg _size="14px">
											<Icon.OutLink />
										</CoreSvg>
									</Grid>
								</a>
							))}
						</Grid>
					</Grid>
					<ReportSectionText>
						{contractedMembers == undefined && `${productPurchase.count}/1`}
						{contractedMembers !== undefined &&
							`${productPurchase.count}/${contractedMembers}명`}
					</ReportSectionText>
				</Grid>
				<StatusBar>
					<FilledBar
						percentage={
							contractedMembers
								? productPurchase.count / contractedMembers
								: productPurchase.count
						}
					/>
				</StatusBar>
			</Grid>
			<Grid>
				<Grid flex="between">
					<Grid flex="start" direction="row" _gap="4px">
						<ReportSectionText>{GRAPH_TITLE[1]}</ReportSectionText>
						<Grid flex="start" _gap="8px">
							{draftSend.link && (
								<a
									key={encodeURIComponent(draftSend.link)}
									href={draftSend.link}
									target="_blank"
									rel="noreferrer"
								>
									<Grid flex="start">
										<Text typo="span" style={{ textDecoration: 'underline' }}>
											Link1
										</Text>
										<CoreSvg _size="14px">
											<Icon.OutLink />
										</CoreSvg>
									</Grid>
								</a>
							)}
						</Grid>
					</Grid>

					<ReportSectionText>
						{contractedMembers !== undefined &&
							`${draftSend.count}/${contractedMembers}명`}
						{contractedMembers == undefined && `${draftSend.count}/1`}
					</ReportSectionText>
				</Grid>
				<StatusBar>
					<FilledBar
						percentage={
							contractedMembers ? draftSend.count / contractedMembers : draftSend.count
						}
					/>
				</StatusBar>
			</Grid>
			<Grid>
				<Grid flex="between">
					<Grid flex="start" direction="row" _gap="4px">
						<ReportSectionText>{GRAPH_TITLE[2]}</ReportSectionText>
						<Grid flex="start" _gap="8px">
							{reelsUpload.link && (
								<a
									key={encodeURIComponent(reelsUpload.link)}
									href={reelsUpload.link}
									target="_blank"
									rel="noreferrer"
								>
									<Grid flex="start">
										<Text typo="span" style={{ textDecoration: 'underline' }}>
											Link1
										</Text>
										<CoreSvg _size="14px">
											<Icon.OutLink />
										</CoreSvg>
									</Grid>
								</a>
							)}
						</Grid>
					</Grid>

					<ReportSectionText>
						{contractedMembers !== undefined &&
							`${reelsUpload.count}/${contractedMembers}명`}
						{contractedMembers == undefined && `${reelsUpload.count}/1`}
					</ReportSectionText>
				</Grid>
				<StatusBar>
					<FilledBar
						percentage={
							contractedMembers
								? reelsUpload.count / contractedMembers
								: reelsUpload.count
						}
					/>
				</StatusBar>
			</Grid>
			<Grid>
				<Grid flex="between">
					<Grid flex="start" direction="row" _gap="4px">
						<ReportSectionText>{GRAPH_TITLE[3]}</ReportSectionText>
						<Grid flex="start" _gap="8px">
							{styleClipUpload.link && (
								<a
									key={encodeURIComponent(styleClipUpload.link)}
									href={styleClipUpload.link}
									target="_blank"
									rel="noreferrer"
								>
									<Grid flex="start">
										<Text typo="span" style={{ textDecoration: 'underline' }}>
											Link1
										</Text>
										<CoreSvg _size="14px">
											<Icon.OutLink />
										</CoreSvg>
									</Grid>
								</a>
							)}
						</Grid>
					</Grid>

					<ReportSectionText>
						{contractedMembers !== undefined &&
							`${styleClipUpload.count}/${contractedMembers}명`}
						{contractedMembers == undefined && `${styleClipUpload.count}/1`}
					</ReportSectionText>
				</Grid>
				<StatusBar>
					<FilledBar
						percentage={
							contractedMembers
								? styleClipUpload.count / contractedMembers
								: styleClipUpload.count
						}
					/>
				</StatusBar>
			</Grid>
		</Grid>
	);
};

const { Grid, Text } = style;

const StatusBar = styled.div`
	width: 100%;
	height: 8px;
	background-color: #d9d9d9;
	border-radius: 4px;
`;

const FilledBar = styled.div<{ percentage: number }>`
	width: ${({ percentage }) => percentage * 100}%;
	height: 100%;
	background-color: ${({ theme }) => theme.colors.uplus.primary50_key};
	border-radius: 4px;
`;

export default MissionProgressGraph;
